'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chartDimensionOptions = exports.chartDimensionToOption = exports.dimensionWithValuesToOptions = exports.artefactToOption = exports.optionsParser = exports.optionParser = exports.getGroupedDimensions = exports.getPropertyDimension = exports.toState = exports.getDimensionsWithValues = exports.hasFocus = exports.isChart = exports.isInt = exports.isNaturalInt = exports.isPositiveNumber = exports.isNumber = undefined;

var _ramda = require('ramda');

var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');

var _ = require('../');

var _constants = require('../constants');

var _dimensionUtils = require('../dimension-utils');

var isNumber = exports.isNumber = function isNumber(input) {
  var value = Number(input);
  return (0, _ramda.not)((0, _ramda.isNil)(value) || isNaN(value));
};

var isPositiveNumber = exports.isPositiveNumber = function isPositiveNumber(input) {
  return isNumber(input) && Number(input) >= 0;
};

var isNaturalInt = exports.isNaturalInt = function isNaturalInt(value) {
  return (0, _ramda.isNil)(value) || /^\d+$/.test(String(value));
};

var isInt = exports.isInt = function isInt(value) {
  return (0, _ramda.isNil)(value) || /^-?\d+$/.test(String(value));
};

var isChart = exports.isChart = function isChart(type) {
  return (0, _ramda.has)(type, _constants.TYPES);
};

var hasFocus = exports.hasFocus = function hasFocus(type) {
  return (0, _ramda.has)(type, (0, _ramda.omit)([_constants.CHORO], _constants.TYPES));
};

var getDimensionsWithValues = exports.getDimensionsWithValues = function getDimensionsWithValues(data) {
  return (0, _ramda.pipe)(_.splitDimensions, (0, _ramda.prop)('values'))(data);
};

var toState = exports.toState = function toState(artefact) {
  return (0, _ramda.prop)('id', artefact);
};

var getPropertyDimension = exports.getPropertyDimension = function getPropertyDimension(property) {
  return function (data, state) {
    var statePropertyDimensionId = (0, _ramda.prop)(property, state);

    var _extractSdmxArtefacts = (0, _.extractSdmxArtefacts)(data),
        dimensions = _extractSdmxArtefacts.dimensions;

    return (0, _ramda.find)((0, _ramda.propEq)('id', statePropertyDimensionId), dimensions);
  };
};

var getGroupedDimensions = exports.getGroupedDimensions = (0, _ramda.pipe)(getDimensionsWithValues, (0, _ramda.groupBy)(function (dimension) {
  if ((0, _dotstatsuiteSdmxjs.isRefAreaDimension)(dimension)) {
    return 'area';
  }
  if ((0, _dotstatsuiteSdmxjs.isTimePeriodDimension)(dimension)) {
    return 'time';
  }
  return 'other';
}));

var optionParser = exports.optionParser = function optionParser(option) {
  return (0, _ramda.pipe)(function (option) {
    return (0, _ramda.is)(Array, option) ? (0, _ramda.head)(option) : option;
  }, function (option) {
    return (0, _ramda.is)(Object, option) ? (0, _ramda.prop)('value', option) : option;
  }, function (option) {
    return (0, _ramda.is)(String, option) ? option : undefined;
  })(option);
};

var optionsParser = exports.optionsParser = function optionsParser(selection) {
  return (0, _ramda.pipe)(function (selection) {
    return (0, _ramda.is)(Array, selection) ? selection : [selection];
  }, function (selection) {
    return (0, _ramda.map)(optionParser, selection);
  })(selection);
};

var artefactToOption = exports.artefactToOption = function artefactToOption(display) {
  return function (artefact) {
    return (0, _ramda.isNil)(artefact) ? undefined : {
      label: (0, _dimensionUtils.dimensionValueDisplay)((0, _.parseDisplay)(display))(artefact),
      value: (0, _ramda.prop)('id', artefact)
    };
  };
};

var dimensionWithValuesToOptions = exports.dimensionWithValuesToOptions = function dimensionWithValuesToOptions(_ref) {
  var data = _ref.data,
      display = _ref.display;
  return (0, _ramda.pipe)(getDimensionsWithValues, (0, _ramda.map)(artefactToOption(display)))(data);
};

var chartDimensionToOption = exports.chartDimensionToOption = function chartDimensionToOption(property) {
  return function (_ref2, state) {
    var data = _ref2.data,
        display = _ref2.display;
    return (0, _ramda.pipe)(getPropertyDimension(property), artefactToOption(display))(data, state);
  };
};

var chartDimensionOptions = exports.chartDimensionOptions = function chartDimensionOptions(_ref3, typeValidator) {
  var data = _ref3.data,
      type = _ref3.type,
      display = _ref3.display;

  if (!typeValidator(type)) {
    return [];
  }
  var dimensions = (0, _ramda.prop)('values', (0, _.splitDimensions)(data));
  if (((0, _ramda.equals)(type, _constants.STACKED_BAR) || (0, _ramda.equals)(type, _constants.STACKED_ROW)) && (0, _ramda.length)(dimensions) === 1) {
    return [];
  }
  return (0, _ramda.map)(artefactToOption(display), dimensions);
};